import { styled } from '@mui/material';
import { FormContainer } from '../../../../../components/Form/FormComponents';

export const FormCardContainer = styled(FormContainer)`
  gap: 0.5rem;
  padding-bottom: 1rem;
`;
